import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import LeadershipFacilitation from "../pages/leadership-facilitation/page";
import ExecutiveCoaching from "../pages/executive-coaching/page";
import OrganizationalStrategy from "../pages/organizational-strategy/page";
import PrivacyPolicy from "../pages/privacy-policy/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/leadership-facilitation",
    element: <LeadershipFacilitation />,
  },
  {
    path: "/executive-coaching",
    element: <ExecutiveCoaching />,
  },
  {
    path: "/organizational-strategy",
    element: <OrganizationalStrategy />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicy />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;